import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect, useSelector } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import ProfileForm from "pages/Profile/ProfileForm";


const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const [auth] = useState(JSON.parse(sessionStorage.getItem("user")))
  const [username, setusername] = useState(null);
  const [avatar, setAvatar] = useState()
  const [modalOpen, setModal] = useState(false);

  const toggleModal = () => setModal(!modalOpen);

  useEffect(() => {
    setusername(auth?.id.role?.name)
  }, [props.success]);

  useEffect(() => {
    import(
      "assets/images/" + process.env.REACT_APP_STYLE_TEMPLATE + "/avatar.svg"
    ).then(setAvatar)
  }, [])

  const { current, profile } = useSelector(state => {
    return ({
      current: state.Dashboard.user,
      profile: state.Suppliers.supplierProfile
    })
  })

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={avatar?.default}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1">{username}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {current?.supplier && (<DropdownItem tag="a" onClick={toggleModal}>
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("global:profile")}
          </DropdownItem>)}
          <DropdownItem tag="a" href="/pages-faqs">
            <i className="bx bx-lock-open font-size-16 align-middle me-1" />
            {props.t("global:faqs")}
          </DropdownItem>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("global:exit")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
      <ProfileForm isOpen={modalOpen} toggle={toggleModal} />
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
